import React from 'react'
import injectSheet from 'react-jss'
import styles from './button.styles'
import classNames from 'classnames'

// eslint-disable-next-line no-unused-vars
const Button = ({ theme, classes, className, children, icon, ...props }) => (
  <a
    className={classNames(
      classes.button,
      className,
      'metrics__slide-settings-button'
    )}
    {...props}>
    {icon && <div className={classes.iconHolder}>{icon}</div>}
    <span>{children}</span>
  </a>
)

export default injectSheet(styles)(Button)
